/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as LogoutCallbackRouteImport } from './routes/logout.callback'
import { Route as LoginCallbackRouteImport } from './routes/login.callback'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const LogoutCallbackRoute = LogoutCallbackRouteImport.update({
  id: '/logout/callback',
  path: '/logout/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginCallbackRoute = LoginCallbackRouteImport.update({
  id: '/login/callback',
  path: '/login/callback',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/login/callback': typeof LoginCallbackRoute
  '/logout/callback': typeof LogoutCallbackRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login/callback': typeof LoginCallbackRoute
  '/logout/callback': typeof LogoutCallbackRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/login/callback': typeof LoginCallbackRoute
  '/logout/callback': typeof LogoutCallbackRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths: '/' | '/login/callback' | '/logout/callback'
  fileRoutesByTo: FileRoutesByTo
  to: '/' | '/login/callback' | '/logout/callback'
  id: '__root__' | '/' | '/login/callback' | '/logout/callback'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  LoginCallbackRoute: typeof LoginCallbackRoute
  LogoutCallbackRoute: typeof LogoutCallbackRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/logout/callback': {
      id: '/logout/callback'
      path: '/logout/callback'
      fullPath: '/logout/callback'
      preLoaderRoute: typeof LogoutCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login/callback': {
      id: '/login/callback'
      path: '/login/callback'
      fullPath: '/login/callback'
      preLoaderRoute: typeof LoginCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  LoginCallbackRoute: LoginCallbackRoute,
  LogoutCallbackRoute: LogoutCallbackRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
